"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HistoryBack_1 = __importDefault(require("./HistoryBack"));
exports.default = HistoryBack_1.default;
